import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { BookingSummaryLayout } from '../shared/summary/BookingSummaryLayout';
import { ExtrasMain } from './ExtrasMain';
import { ExtrasSubmit } from './ExtrasSubmit';
import { SelectUpgrades } from './upgrades/SelectUpgrades';
import { useAncillariesFromFormData } from './helpers/useAncillariesFromFormData';
import { useNewBookingStore } from '../../../domain/booking/stores/useNewBookingsStore';
import { ApiErrorMessage } from '../../errors/ApiErrorMessage';

export const ExtrasLayout = observer(() => {
	const ancillaries = useAncillariesFromFormData();
	const {
		originalBooking,
		booking,
		parkingProductsQuoteStore: { error },
	} = useNewBookingStore();

	return (
		<BookingSummaryLayout
			originalBooking={originalBooking}
			booking={{ ...booking, ancillaries }}
			Submit={ExtrasSubmit}
		>
			{error && <StyledApiErrorMessage error={error} />}
			<SelectUpgrades />
			<ExtrasMain />
		</BookingSummaryLayout>
	);
});

const StyledApiErrorMessage = styled(ApiErrorMessage)`
	margin-bottom: 24px;
	margin-top: 0;
`;
